import React, { useState, useEffect } from "react";
import style from "./needhelp.module.css";
import { FiHelpCircle } from "react-icons/fi";
import { Button, Form } from "react-bootstrap";
import { FiBookOpen } from "react-icons/fi";
import { IoIosArrowForward, IoMdClose } from "react-icons/io";
import { MdKeyboardBackspace } from "react-icons/md";
import Concerned from "./Concerned";
import Payout from "./Payout";
import { useNavigate, useLocation } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { jwtDecode } from "jwt-decode";
import {
  AdminPayment,
  createAdminSubscription,
} from "../../apis/paymentApis";
import { toast } from "react-toastify";

import { getToken } from "../../utils/api";

const NeedHelp = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [show, setShow] = useState(false);
  const [step, setStep] = useState(0);

  const [isFooterVisible, setIsFooterVisible] = useState(false);
  const [amount, setAmount] = useState(10);
  const [selectedFrequency, setSelectedFrequency] = useState("1");
  const [Id, setId] = useState("");

  const dispatch = useDispatch();
  // ✅ Auto open when on donation page
  // useEffect(() => {
  //     const params = new URLSearchParams(location.search);
  // const openShare = params.get("openShare");
  

  //   if (location.pathname.startsWith("/donation/")) {
  //         if (openShare == "true") {
  //      setShow(false);
  //   } 
  //   // If NO openShare in URL → open Need Help
  //   else {
  //     setShow(true);
  //   }
  //   } else {
  //     setShow(false);
  //     setStep(0);
  //   }
  // }, [location.pathname]);
  const token = getToken();

  useEffect(() => {
    if (token) {
      const decoded = jwtDecode(token);
      setId(decoded?.sub);
    }
  }, []);

  useEffect(() => {
    const footer = document.getElementById("home-footer");
    if (!footer) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsFooterVisible(entry.isIntersecting);
      },
      {
        root: null,
        threshold: 0.1,
      }
    );

    observer.observe(footer);

    return () => observer.disconnect();
  }, []);

  const handleFrequencyChange = (e) => {
    setSelectedFrequency(e.target.value);
  };
  const handleDonate = () => {
    if (!amount) {
      toast.error("Please select an amount to proceed with payment");
      return;
    }

    const clearAmount = Number(amount);

    if (!isNaN(clearAmount) && clearAmount > 0) {
      if (selectedFrequency === "1") {
        dispatch(
          AdminPayment({
            amount: clearAmount,
            id: Id,
          })
        ).then((res) => {
          if (res?.data) {
            window.location.href = res.data;
          }
        });
      } else {
        dispatch(
          createAdminSubscription({
            amount: clearAmount,
            interval: "month",
            id: Id,
          })
        ).then((res) => {
          if (res?.url) {
            window.location.href = res.url;
          }
        });
      }
    } else {
      toast.error("Invalid amount. Please enter a valid number.");
    }
  };



  return (
    <>
      <div
        className={style.backbutton}
        onClick={() => {
          setShow(!show);
          setStep(0);
        }}
      >
        {/* <div className={`d-flex align-items-center gap-2 ${style.needbutton}`}>
          <FiHelpCircle stroke="white" className="fs-5" />
          {!isFooterVisible && <span className={`fs-6 text-white `}>Need Help</span>}
        </div> */}


      </div>

      {show && (
        <div className={`${style.mainbox} ${(step === 2 || step === 3) ? style.articleBox : ""}`}>
          <div className={`position-relative z-1 ${style.header}`}>
            {step !== 0 && (
              <Button
                variant="light"
                className="position-absolute top-0 start-0 ms-4 mt-4 py-1 px-2 "
                style={{ fontSize: "12px" }}
                onClick={() => setStep(0)}
              >
                <MdKeyboardBackspace className="mdkey" /> Back
              </Button>
            )}
            <Button
              variant="light"
              className=" position-absolute end-0 top-0 cursor-pointer me-4 mt-4 p-1 "
              style={{ fontSize: "12px" }}
              onClick={() => {
                setShow(false);
                setStep(0);
              }}
            >
              <IoMdClose className="mdcloase" />
            </Button>

            {step === 0 && (
              <div className={style.content}>
                <div className="bg-white p-4 rounded-3">
                  <div className="fs-6 fw-bold mb-3">How can we assist you?</div>

                  {/* Option 1: Donate Support */}
                  <div
                    className={`d-flex justify-content-between align-items-center p-3 rounded-3 mb-3 cursor-pointer ${style.contenethover}`}
                    onClick={() => setStep(4)} // ✅ Open donation form
                  >
                    <div className="fs-6 fw-semibold">Donate Support</div>
                    <IoIosArrowForward  className="arrow-forward"/>
                  </div>

                  {/* Option 2: Learn More */}
                  <div
                    className={`d-flex justify-content-between align-items-center p-3 rounded-3 mb-3 cursor-pointer ${style.contenethover}`}
                    onClick={() => setStep(1)}
                  >
                    <div className="fs-6 fw-semibold">Learn More</div>
                    <IoIosArrowForward className="arrow-forward"/>
                  </div>

                  {/* Option 3: Contact Us */}
                  <div
                    className={`d-flex justify-content-between align-items-center p-3 rounded-3 cursor-pointer ${style.contenethover}`}
                    onClick={() => {
                      setShow(false);
                      setStep(0);
                      navigate("/campaign-register");
                    }}
                  >
                    <div className="fs-6 fw-semibold" >Support Us</div>
                    <IoIosArrowForward className="arrow-forward" />
                  </div>
                </div>
              </div>
            )}

            {/* {step == 1 && (
              <div className="text-white fs-3 fw-bold"> FundLife Support</div>
            )} */}
          </div>
          {step == 1 && (
            <div className={style.content}>
              {/* <div className={`z-2 fs-6 fw-bold ${style.contentheader}`}>
                Got Questions?
              </div> */}
              <div className="bg-white p-3 ">
                {/* <div className="position-relative" style={{ marginTop: "-35px" }}>
                  <FaSearch fill="white" className={`${style.absolute} `} />
                  <Form.Control
                    type="text"
                    placeholder="Search for help"
                    className="fs14 fw-semibold"
                    style={{ border: "1px solid #878787" }}
                  />
                </div> */}
                <div className="mt-4 fs12 fw-semibold">Suggested articles</div>
                <div className="">
                  <div
                    className={`d-flex p-3 pe-2 gap-2 rounded-3 mt-2 cursor-pointer ${style.contenethover}`}
                    onClick={() => setStep(2)}
                  >
                    <div>
                      <FiBookOpen className="fs-6" />
                    </div>
                    <div className="fs14">
                      Concerned About a Campaign? Here’s What to do
                    </div>
                  </div>
                  {/* <div
                    className={`d-flex p-3 pe-2 gap-2 rounded-3 mt-2 cursor-pointer ${style.contenethover}`}
                    onClick={() => setStep(3)}
                  >
                    <div>
                      <FiBookOpen className="fs-6" />
                    </div>
                    <div className="fs14">
                      Understanding Payouts: Your Guide to Accessing Funds on
                      FundLife
                    </div>
                  </div> */}
                  {/* <div
                    className={`d-flex p-3 pe-2 gap-2 rounded-3 mt-2 cursor-pointer ${style.contenethover}`}
                  >
                    <div>
                      <FiBookOpen className="fs-6" />
                    </div>
                    <div className="fs14">
                      Starting Your Campaign on FundLife
                    </div>
                  </div> */}
                </div>
              </div>

              {/* <div
                className={` mt-4  bg-white rounded-3 cursor-pointer ${style.contactus}`}
                onClick={() => {
                  setShow(false)
                  setStep(1)
                  navigate("/contactus")
                }}
              >
                <div className=" d-flex justify-content-between">
                  <div className="fs-6 fw-bold">Contact Us</div>
                  <div>
                    <IoIosArrowForward className="" />
                  </div>
                </div>
              </div> */}
            </div>
          )}
          {step == 2 && <Concerned />}
          {step == 3 && <Payout />}
          {step === 4 && (
            <div className={style.content}>
              <div className="bg-white p-4 rounded-3">
                <h5 className="fw-bold mb-3 text-center">
                  Choose Your Donation Amount
                </h5>

                {/* ==== Amount Radio Buttons ==== */}
                <div className={`${style.amountContainer} d-flex justify-content-around`}>
                  {[30, 50, 100].map((val) => (
                    <label
                      key={val}
                      className={`${style.amountOption} ${amount == val ? style.amountOptionSelected : ""
                        }`}
                    >
                      <input
                        type="radio"
                        name="amount"
                        value={val}
                        checked={amount == val}
                        onChange={() => setAmount(val)}
                      />
                      <span>${val}</span>
                    </label>
                  ))}
                </div>

                <div className={style.paymentformmaindonation}>
                  <div className={style.paymentFormdonationcamp}>
                    <div className={style.donationpaymentmaincamp}>
                      <h6 className="text-center mb-3">Choose a donation frequency</h6>

                      {/* ==== Frequency Radio Buttons ==== */}
                      <div className={`${style.donateradiomaincamp} d-flex justify-content-center gap-3`}>
                        <label
                          className={`${style.radioOption} ${selectedFrequency === "1" ? style.radioSelected : ""
                            }`}
                        >
                          <input
                            type="radio"
                            name="frequency"
                            value="1"
                            checked={selectedFrequency === "1"}
                            onChange={handleFrequencyChange}
                          />
                          <span>One-Time</span>
                        </label>

                        <label
                          className={`${style.radioOption} ${selectedFrequency === "month" ? style.radioSelected : ""
                            }`}
                        >
                          <input
                            type="radio"
                            name="frequency"
                            value="month"
                            checked={selectedFrequency === "month"}
                            onChange={handleFrequencyChange}
                          />
                          <span>Monthly</span>
                        </label>
                      </div>

                      {/* ==== Stripe Button ==== */}
                      <div className={style.donationbuttoncontainermaincamp}>
                        <div className={style.smallscreenabutton}>
                          <button onClick={handleDonate}>
                            <img
                              src="/logosstripe.png"
                              alt="Stripe"
                              style={{ height: "20px" }}
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default NeedHelp;